module.exports = __webpack_public_path__ + "img/color-picker.ce03291e.svg";